import script from "./workload-view-summary-block-entries.vue?vue&type=script&setup=true&lang=ts"
export * from "./workload-view-summary-block-entries.vue?vue&type=script&setup=true&lang=ts"

import "./workload-view-summary-block-entries.vue?vue&type=style&index=0&id=7db39d94&scoped=true&lang=scss"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7db39d94"]])

export default __exports__